import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { TooltipEl } from "common/components/tooltip";
import { SelectEl } from "common/components/select";
import { Directions } from "common/components/drop-menu/types";
import { CopyType } from "./types";
export function template() {
  const icon = this.attr(`icon`) || (this.attr(`copy-type`) === CopyType.Copy ? `copy` : `link`);
  if (this.attr(`options`).length === 1) {
    return /* @__PURE__ */ jsx("div", { sel: ".copy-to-clipboard-button" }, /* @__PURE__ */ jsx(
      ButtonEl,
      {
        attrs: {
          ...this.attrs(),
          icon
        },
        on: {
          click: () => this.helpers.copyValue(this.attr(`options`)[0].value)
        }
      },
      this.innerHTML.trim() && /* @__PURE__ */ jsx("slot", null)
    ), /* @__PURE__ */ jsx(
      TooltipEl,
      {
        attrs: {
          "max-width": `64px`,
          text: `Copy`
        }
      }
    ));
  }
  return /* @__PURE__ */ jsx(
    SelectEl,
    {
      sel: ".copy-to-clipboard-select",
      attrs: {
        sections: [{ items: this.attr(`options`).map((option) => ({ label: option.label, value: option.value })) }],
        "icon-only": true,
        icon: { leftIcon: icon },
        "menu-width": 200,
        "menu-alignment": Directions.Up
      },
      on: { change: (ev) => this.helpers.copyValue(ev.detail.item.value) }
    }
  );
}
